/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

import {
  CardWidget,
  ICardWidgetProps,
  RankingWidget,
  IRankingWidgetProps,
  TopAuthorsWidget,
  ITopAuthorsWidgetProps,
  AcquisitionWidget,
  IAcquisitionWidgetProps,
  ProgressTrackWidget,
  IProgressTrackWidgetProps,
  RatingsWidget,
  IRatingsWidgetProps,
  EventsWidget,
  IEventsWidgetProps,
  PeriodOverviewWidget,
  IPeriodOverviewWidgetProps,
  SalesValueWidget,
  ISalesValueWidgetProps,
  RankingTableWidget,
  IRankingTableWidgetProps,
  AppCardWidget,
  IAppCardWidgetProps,
  ChoroplethMapWidget,
  IChoroplethMapWidgetProps,
  IAnimatedWidgetCompProps,
  AnimatedSalesValueWidget,
} from './components';

export interface IAnalyticsMainSectionProps {
  type:
    | 'card-widget'
    | 'ranking-widget'
    | 'top-authors-widget'
    | 'acquisition-widget'
    | 'progress-track-widget'
    | 'ratings-widget'
    | 'events-widget'
    | 'period-overview-widget'
    | 'sales-value-widget'
    | 'ranking-table-widget'
    | 'app-card-widget'
    | 'choropleth-map-widget'
    | 'animated-chart';
  key: string;
  compProps:
    | ICardWidgetProps
    | IRankingWidgetProps
    | ITopAuthorsWidgetProps
    | IAcquisitionWidgetProps
    | IProgressTrackWidgetProps
    | IRatingsWidgetProps
    | IEventsWidgetProps
    | IPeriodOverviewWidgetProps
    | ISalesValueWidgetProps
    | IRankingTableWidgetProps
    | IAppCardWidgetProps
    | IChoroplethMapWidgetProps;
  col: {
    xs?: number;
    md?: number;
    lg?: number;
  };
}

export interface IAnalyticsLayoutProps {
  isRowCenter?: boolean;
  colProps?: IAnalyticsMainSectionProps[];
}

export interface IAnalyticsWidgetProps {
  layout: IAnalyticsLayoutProps[];
  highest?: any;
  isTotalCount?: boolean;
  totalCount?: any;
  onAppCardClick?(): any;
  backgroundTitle?: any;
  hoverColor?: any;
  backgroundColor?: any;
}

export const AnalyticsWidget = ({
  layout,
  highest,
  isTotalCount,
  totalCount,
  hoverColor,
  onAppCardClick,
  backgroundColor,
  backgroundTitle,
}: IAnalyticsWidgetProps) => {
  console.log('highest==>', highest);
  const _renderNull = () => {
    const data = [
      {
        ISO3: 'unknown',
        Name: 'unknown',
        count: 1,
      },
    ];
    return (
      <>
        <ChoroplethMapWidget data={data} message="Analytics" />
      </>
    );
  };
  const _renderWidgets = () => {
    let _comp: any = [];
    for (let i = 0; i < layout?.length; ++i) {
      const _layout = layout[i];
      _comp.push(
        <Row
          // className={_layout?.isRowCenter ? 'justify-content-lg-center' : ''}
        >
          {_layout?.colProps?.map((_col, index) => {
            switch (_col?.type) {
              case 'card-widget':
                return (
                  <Col
                    key={`${_col.type}-${i}-${_col.key}`}
                    xs={12 / _col?.col?.xs}
                    md={12 / _col?.col?.md}
                    lg={12 / _col?.col?.lg}
                    style={{ paddingBottom: '20px' }}
                  >
                    <CardWidget {...(_col?.compProps || {})} />
                  </Col>
                );
              case 'choropleth-map-widget':
                if (_col?.compProps?.data.length > 0) {
                  return (
                    <Col
                      key={`${_col.type}-${i}-${_col.key}`}
                      xs={12 / _col?.col?.xs}
                      md={12 / _col?.col?.md}
                      lg={12 / _col?.col?.lg}
                      style={{ paddingBottom: '20px' }}
                    >
                      <ChoroplethMapWidget
                        highest={highest}
                        {...(_col?.compProps || {})}
                      />
                    </Col>
                  );
                } else {
                  return (
                    <Col
                      key={`${_col.type}-${i}-${_col.key}`}
                      xs={12 / _col?.col?.xs}
                      md={12 / _col?.col?.md}
                      lg={12 / _col?.col?.lg}
                      style={{ paddingBottom: '20px' }}
                    >
                      {_renderNull()}
                    </Col>
                  );
                }

              case 'app-card-widget':
                if (_col?.compProps?.appCardId !== undefined) {
                  console.log('comprops==>', _col?.compProps?.appCardId);
                  return (
                    <Col
                      key={`${_col.type}-${i}-${_col.key}`}
                      xs={12 / _col?.col?.xs}
                      md={12 / _col?.col?.md}
                      lg={12 / _col?.col?.lg}
                      style={{ paddingBottom: '20px' }}
                    >
                      <AppCardWidget
                        onAppCardClick={onAppCardClick}
                        backgroundColor={backgroundColor}
                        hoverColor={hoverColor}
                        backgroundTitle={backgroundTitle}
                        {...(_col?.compProps || {})}
                      />
                    </Col>
                  );
                } else {
                  return null;
                }

              case 'ranking-widget':
                return (
                  <Col
                    key={`${_col.type}-${i}-${_col.key}`}
                    xs={12 / _col?.col?.xs}
                    md={12 / _col?.col?.md}
                    lg={12 / _col?.col?.lg}
                    style={{ paddingBottom: '20px' }}
                  >
                    <RankingWidget {...(_col?.compProps || {})} />
                  </Col>
                );
              case 'top-authors-widget':
                return (
                  <Col
                    key={`${_col.type}-${i}-${_col.key}`}
                    xs={12 / _col?.col?.xs}
                    md={12 / _col?.col?.md}
                    lg={12 / _col?.col?.lg}
                    style={{ paddingBottom: '20px' }}
                  >
                    <TopAuthorsWidget {...(_col?.compProps || {})} />
                  </Col>
                );
              case 'acquisition-widget':
                return (
                  <Col
                    key={`${_col.type}-${i}-${_col.key}`}
                    xs={12 / _col?.col?.xs}
                    md={12 / _col?.col?.md}
                    lg={12 / _col?.col?.lg}
                    style={{ paddingBottom: '20px' }}
                  >
                    <AcquisitionWidget {...(_col?.compProps || {})} />
                  </Col>
                );
              case 'progress-track-widget':
                return (
                  <Col
                    key={`${_col.type}-${i}-${_col.key}`}
                    xs={12 / _col?.col?.xs}
                    md={12 / _col?.col?.md}
                    lg={12 / _col?.col?.lg}
                    style={{ paddingBottom: '20px' }}
                  >
                    <ProgressTrackWidget {...(_col?.compProps || {})} />
                  </Col>
                );
              case 'ratings-widget':
                return (
                  <Col
                    key={`${_col.type}-${i}-${_col.key}`}
                    xs={12 / _col?.col?.xs}
                    md={12 / _col?.col?.md}
                    lg={12 / _col?.col?.lg}
                    style={{ paddingBottom: '20px' }}
                  >
                    <RatingsWidget {...(_col?.compProps || {})} />
                  </Col>
                );
              case 'events-widget':
                return (
                  <Col
                    key={`${_col.type}-${i}-${_col.key}`}
                    xs={12 / _col?.col?.xs}
                    md={12 / _col?.col?.md}
                    lg={12 / _col?.col?.lg}
                    style={{ paddingBottom: '20px' }}
                  >
                    <EventsWidget {...(_col?.compProps || {})} />
                  </Col>
                );
              case 'period-overview-widget':
                return (
                  <Col
                    key={`${_col.type}-${i}-${_col.key}`}
                    xs={12 / _col?.col?.xs}
                    md={12 / _col?.col?.md}
                    lg={12 / _col?.col?.lg}
                    style={{ paddingBottom: '20px' }}
                  >
                    <PeriodOverviewWidget
                      {...(_col?.compProps || {})}
                      ChartComponent={() => <div />}
                    />
                  </Col>
                );
              case 'sales-value-widget':
                return (
                  <Col
                    key={`${_col.type}-${i}-${_col.key}`}
                    xs={12 / _col?.col?.xs}
                    md={12 / _col?.col?.md}
                    lg={12 / _col?.col?.lg}
                    style={{ paddingBottom: '20px' }}
                  >
                    <SalesValueWidget
                      isTotalCount={isTotalCount}
                      totalCount={totalCount}
                      {...(_col?.compProps || {})}
                    />
                  </Col>
                );
              case 'animated-chart':
                return (
                  <Col
                    key={`${_col.type}-${i}-${_col.key}`}
                    xs={12 / _col?.col?.xs}
                    md={12 / _col?.col?.md}
                    lg={12 / _col?.col?.lg}
                    style={{ paddingBottom: '20px' }}
                  >
                    <AnimatedSalesValueWidget {...(_col?.compProps || {})} />
                  </Col>
                );
              case 'ranking-table-widget':
                return (
                  <Col
                    key={`${_col.type}-${i}-${_col.key}`}
                    xs={12 / _col?.col?.xs}
                    md={12 / _col?.col?.md}
                    lg={12 / _col?.col?.lg}
                    style={{ paddingBottom: '20px' }}
                  >
                    <RankingTableWidget {...(_col?.compProps || {})} />
                  </Col>
                );
              default:
                return <></>;
              // case "app-card-widget":
              //   return (
              //     <Col
              //       key={`${_col.type}-${i}-${_col.key}`}
              //       xs={12 / _col?.col?.xs}
              //       md={12 / _col?.col?.md}
              //       lg={12 / _col?.col?.lg}
              //       style={{ paddingBottom: "20px" }}
              //     >
              //       <AppCardWidget {...(_col?.compProps || {})} />
              //     </Col>
              //   );
            }
          })}
        </Row>
      );
    }

    return _comp;
  };
  return <>{_renderWidgets()}</>;
};

AnalyticsWidget.defaultProps = {
  sections: [],
  isTotalCount: false,
};
